import React, {useImperativeHandle, useRef} from 'react'
import {useTranslation} from '@lib/intl/useTranslations'
import WizButton from '@component/buttons/WizButton'
import useSnackbar from '@hook/useSnackbar'
import Text from '@component/Text/Text'
import useChangeCurrency from '@hook/useCurrencyChange'
import WizContentModal from '@component/modal/WizContentModal'
import {createLog} from '@util/logs'

interface IProps {
    refreshCallback?: () => void
}

const ChangeCurrencyModal = ({refreshCallback}: IProps, ref: any) => {
    const modalRef = useRef<any>()
    const t = useTranslation()
    const {showSnackbar} = useSnackbar()

    const {options: currencyOptions} = useChangeCurrency()

    useImperativeHandle(ref, () => ({
        show: () => {
            modalRef.current.show()
        },
    }))

    return (
        <WizContentModal size={'600'} title={t('modal.changeCurrency.title')} ref={modalRef}>
            <div className={'space-y-[10px] mt-[10px]'}>
                {currencyOptions?.map(item => (
                    <div
                        key={item?.id}
                        onClick={() => {
                            createLog('event', 'currency_modal_change_currency', {currency: item?.id})
                            item?.onClick()
                            showSnackbar(t('modal.changeCurrency.submit.res.success'))
                            modalRef?.current?.close()
                        }}
                        className={
                            'p-[20px] rounded-[3px] border-gray07 dark:border-dark_gray07 border cursor-pointer hover:bg-gray09 dark:hover:bg-dark_gray09 active:bg-gray07 dark:active:bg-dark_gray07'
                        }>
                        <Text className="text-gray01 dark:text-dark_gray01">{item?.title}</Text>
                    </div>
                ))}
            </div>
            <div className={'grid gap-[5px] mt-[20px]'}>
                <WizButton
                    text={t('modal.changeCurrency.submit.cancel')}
                    buttonType={'border'}
                    onClick={() => modalRef.current.close()}
                />
            </div>
        </WizContentModal>
    )
}

export default React.forwardRef(ChangeCurrencyModal)
